import React from 'react';

const IframeModal = ({ isOpen, onClose, src, title }) => {
  if (!isOpen) return null;

  // Check if it's a WhatsApp flow URL
  const isWhatsAppFlow = src.includes('business.facebook.com/wa/manage/flows');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-hidden">
      <div className={`bg-white rounded-lg shadow-lg flex flex-col ${isWhatsAppFlow ? 'h-auto' : 'w-full max-w-5xl h-5/6'}`}>
        <div className="p-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-medium text-gray-900">{title || 'Preview'}</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none text-2xl"
          >
            &times;
          </button>
        </div>
        <div className={`${isWhatsAppFlow ? 'p-0' : 'flex-grow p-4'} overflow-auto flex justify-center`}>
          <iframe 
            src={src} 
            className="border-0" 
            style={{
              width: isWhatsAppFlow ? '480px' : '100%',
              height: isWhatsAppFlow ? '840px' : '100%',
              maxHeight: isWhatsAppFlow ? '80vh' : '100%'
            }}
            title={title || "Preview"}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            loading="lazy"
            scrolling={isWhatsAppFlow ? "yes" : "auto"}
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default IframeModal;
